import { Routes as Router, Route } from "react-router-dom"
import CheckoutPage from "../pages/Checkout"
import CheckoutSuccessPage from "../pages/Checkout/Success"
import HomePage from "../pages/Home"
import SuccessOrder from "../pages/Checkout/SuccessOrder"
import React from "react"
import { isWidget } from "../core/constants"
import OrderSuccessRedirectPage from "../pages/Checkout/Redirects/OrderSuccessRedirectPage"
import OrderThanksRedirectPage from "../pages/Checkout/Redirects/OrderThanksRedirectPage"
import AffiliatedRedirectPage from "../pages/Checkout/Redirects/AffiliatedRedirectPage"
import AffiliatedIntermediaryRedirectPage from "../pages/Checkout/Redirects/AffiliatedIntermediaryRedirectPage"

const Routes = () => {
  if (isWidget()) {
    return (
      <Router>
        <Route index element={<CheckoutPage />} />
        <Route path="/*" element={<CheckoutPage />} />
      </Router>
    )
  }

  return (
    <Router>
      <Route index element={<HomePage />} />

      {/** Checkout principal de produto */}
      <Route path="/:codeId" element={<CheckoutPage />} />

      {/** Checkout principal de produto sem comissão para afiliado */}
      <Route path="/pro/:codeId" element={<CheckoutPage />} />

      {/** Página para redirecionamento de marcação de cookie */}
      <Route
        path="/:codeId/redirect"
        element={<AffiliatedIntermediaryRedirectPage />}
      />

      {/** Página para marcação de cookie */}
      <Route path="/:codeId/affiliated" element={<AffiliatedRedirectPage />} />

      {/** Checkout para recuperação de compra */}
      <Route path="/c/:checkoutOrderCodeId" element={<CheckoutPage />} />

      {/** Checkout para troca de cartão de uma assinatura */}
      <Route path="/sub/:subscriptionCodeId" element={<CheckoutPage />} />

      {/** Checkout principal de ticket */}
      <Route path="/t/:areaCodeId" element={<CheckoutPage />} />

      {/** Página de redirecionamento para sucesso */}
      <Route
        path="/:codeId/success/redirect"
        element={<OrderSuccessRedirectPage />}
      />

      {/** Pãgina de redirecionamento para obrigado */}
      <Route
        path="/:codeId/thanks/redirect"
        element={<OrderThanksRedirectPage />}
      />

      {/** Pãgina de compra realizada com sucesso, gerar código para pagamento (QrCode | Código de barras) */}
      <Route path="/:codeId/success" element={<CheckoutSuccessPage />} />

      {/** Página de obrigado pelo pagamento e redirecionamento caso exista configuração */}
      <Route path="/:codeId/thanks" element={<SuccessOrder />} />
    </Router>
  )
}

export default Routes
